// extracted by mini-css-extract-plugin
export var img = "Resources-module--img--h3vby";
export var inner = "Resources-module--inner--3lxZG";
export var link = "Resources-module--link--L5Lu+";
export var list = "Resources-module--list--i2OhI";
export var resource = "Resources-module--resource--RHDJE";